import React, { useState } from 'react';

const DISMISS_KEY = 'codzisiaj-news-banner-dismissed';

function AndroidIcon() {
  return (
    <svg className="news-banner-os-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M17.6 9.48l1.84-3.18a.5.5 0 0 0-.2-.7.5.5 0 0 0-.68.2l-1.86 3.22A7.3 7.3 0 0 0 12 7.5c-1.7 0-3.26.58-4.7 1.52L5.44 5.8a.5.5 0 0 0-.68-.2.5.5 0 0 0-.2.7L6.4 9.48C4.36 11.02 3 13.37 3 16v1h18v-1c0-2.63-1.36-4.98-3.4-6.52zM9 15.25a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5zm6 0a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z"
      />
    </svg>
  );
}

function IosIcon() {
  return (
    <svg className="news-banner-os-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16.7 12.4c-.03-2.3 1.88-3.4 1.96-3.45-1.07-1.56-2.74-1.78-3.33-1.8-1.42-.14-2.77.83-3.49.83-.72 0-1.84-.81-3.03-.79-1.56.02-3 1.9-3.77 3.62-1.61 2.79-.41 6.92 1.15 9.18.77 1.11 1.68 2.35 2.88 2.3 1.16-.05 1.6-.74 3-.74s1.8.74 3.02.72c1.25-.02 2.04-1.13 2.8-2.25.88-1.28 1.24-2.52 1.26-2.58-.03-.01-2.42-.93-2.45-3.04zM14.6 5.9c.64-.77 1.07-1.85.95-2.92-1.02.04-2.25.68-2.98 1.54-.65.76-1.22 1.86-1.07 2.96 1.13.09 2.28-.57 3.1-1.58z"
      />
    </svg>
  );
}

/** Baner nowości — tymczasowy, na jeden dzień. Po dniu usuń <NewsBanner /> z App.tsx. */
export default function NewsBanner() {
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  if (hidden) return null;

  const dismiss = () => {
    setHidden(true);
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* ignore */
    }
  };

  return (
    <aside className="news-banner" role="status">
      <div className="news-banner-text">
        <p>
          <strong>Nowe funkcje</strong> — aplikacja{' '}
          <span className="news-banner-os-icons" aria-label="Android i iOS">
            <AndroidIcon />
            <IosIcon />
          </span>
          , filtrowanie po województwach oraz mapa z wydarzeniami{' '}
          <span aria-hidden="true">🗺️</span> już są!
        </p>
        <p className="news-banner-line">
          Dziękujemy, że jesteście z nami! Wpadnijcie również na Instagrama{' '}
          <span aria-hidden="true">📸</span>{' '}
          <a
            href="https://www.instagram.com/codzisiajcom"
            target="_blank"
            rel="noopener noreferrer"
          >
            @codzisiajcom
          </a>
          {' '}oraz TikToka{' '}
          <a
            href="https://www.tiktok.com/@codzisiaj3"
            target="_blank"
            rel="noopener noreferrer"
          >
            @codzisiaj3
          </a>
          . Udanej zabawy!
        </p>
      </div>
      <button type="button" className="news-banner-close" onClick={dismiss} aria-label="Zamknij">
        ×
      </button>
    </aside>
  );
}
